import React from 'react';
import { withTheme } from 'styled-components';
export var AguaIcon = function AguaIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "179px",
    height: "266px",
    viewBox: "0 0 179 266",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Agua"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Agua",
    transform: "translate(-90.000000, -1.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "12"
  }, React.createElement("g", {
    transform: "translate(96.000000, 7.000000)",
    id: "Group"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M166.27,171.08 C166.27,216.74 129.25,253.76 83.59,253.76 C37.93,253.76 0.91,216.74 0.91,171.08 C0.91,125.42 83.6,0.14 83.6,0.14 C83.6,0.14 166.27,125.42 166.27,171.08 Z",
    id: "Path"
  }), React.createElement("path", {
    d: "M83.05,225.26 C53.84,225.26 30.15,201.58 30.15,172.36",
    id: "Path"
  }))))));
};
export default withTheme(AguaIcon);